<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="previewStream()" >
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">报警中心</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('alarm-device-manage')" v-if="permissionCodes.indexOf('022001000') !== -1">
        <i class="el-icon-damai-shebei2"></i>
        <span slot="title">设备管理</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('police-receiver')" v-if="permissionCodes.indexOf('022002000') !== -1">
        <i class="el-icon-damai-jingli"></i>
        <span slot="title">接警人管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('alarm-linkage')" v-if="permissionCodes.indexOf('022003000') !== -1">
        <i class="el-icon-damai-alarm-config" style="font-size: 20px;"></i>
        <span slot="title">报警联动</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('alarm-record')" v-if="permissionCodes.indexOf('022005000') !== -1">
        <i class="el-icon-damai--baojingjilu"></i>
        <span slot="title">报警记录</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('police-insert-record')" v-if="permissionCodes.indexOf('022006000') !== -1">
        <i class="el-icon-damai-jiejingjilu"></i>
        <span slot="title">接警记录</span>
      </el-menu-item>
      <el-submenu index="1" v-if="permissionCodes.indexOf('') !== -1 || permissionCodes.indexOf('') !== -1 || permissionCodes.indexOf('') !== -1">
        <template slot="title">
          <i class="el-icon-damai-shebeiguanli1"></i>
          <span>报警统计</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="9-1" @click="toNewRouter('statistics-by-date')" v-if="permissionCodes.indexOf('') !== -1">按日期统计</el-menu-item>
          <el-menu-item index="9-3" @click="toNewRouter('statistics-by-person')" v-if="permissionCodes.indexOf('') !== -1">按接警人统计</el-menu-item>
          <el-menu-item index="9-2" @click="toNewRouter('statistics-by-device')" v-if="permissionCodes.indexOf('') !== -1">按设备统计</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="8" @click="toNewRouter('alarm-manage-log')" v-if="permissionCodes.indexOf('022007000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  2: ["police-receiver", "police-receiver-add", "police-receiver-modify"],
  3: [
    "alarm-linkage",
    "alarm-linkage-add",
    "alarm-linkage-plan-add",
    "alarm-linkage-plan-modify"
  ],
  4: ["alarm-record"],
  5: ["police-insert-record"],
  7: ["alarm-device-manage", "alarm-device-add", "alarm-device-modify"],
  8: "alarm-manage-log",
  9: ["statistics-by-date", "statistics-by-person", "statistics-by-device"],
});

export default {
  name: "alarm-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    },
    previewStream() {
      window.open(
        `https://yq.damaiiot.com/upper_strata/park_display_screen`,
        "_blank"
      );
      // window.open(`https://yq.damaiiot.com/dataPage.html#/fire_control_login_without/${bus.global.yqCode}/${bus.global.yqName}/${bus.global.accountCode}/${bus.global.personCode || 'null'}/${bus.global.personName || 'null'}`, '_blank')
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/AlarmManage/AlarmNav.vue